<template>
  <div class="ficha-mapa ficha-mineria">
    <div class="encabezado">Minería</div>
    <div class="contenedor">
      
      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img class="foto" src="@/assets/fichas-diagnostico/minas/Mina-Tlaminca.png" alt="" />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Mina y banco de Tlaminca, Texcoco</p>
          </div>
          <div class="ficha-titulo">
            <h4>Minería en la RNOCM</h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              El proyecto del exNAICM requirió la
              <b>explotación mineral de arena, grava y tezontle.</b> Para la
              nivelación y relleno de la superficie del polígono de la Zona
              Federal del Lago de Texcoco se utilizaron 41,500,000.00 m3 de
              material pétreo. Esto requirió que se explotaran
              <b>233 bancos de materiales ubicados</b> en municipios de la
              <b>Ciudad de México, Estado de México, Hidalgo y Tlaxcala.</b>
            </p>
            <h4>Presencia de minas en la RNOCM</h4>
            <img
              src="@/assets/fichas-diagnostico/minas/Presencia-Minas-Barras.png"
              alt="México 264, Hidalgo 70, Tlaxcala 3, CDMX 1"
              class="vis m-b-1"
            />
          </div>
        </div>
      </div>
      
      <div class="ficha-separador"></div>
      
      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img src="@/assets/fichas-diagnostico/minas/Mina-Tlapacoya.png" class="foto" alt="" />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Mina Tlapacoya, Ixtapaluca en 2008 y 2020</p>
          </div>
          <div class="ficha-titulo">
            <h4>Situación de las minas en la RNOCM</h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              Con el análisis realizado de los bancos de materiales, se
              identificaron <b>casos de ilegalidad</b> en los aprovechamientos
              mineros;
              <b>discrepancias entre la superficie explotada y la registrada</b>
              en los permisos ambientales;
              <b>impactos a viviendas y en áreas naturales protegidas,</b> y las
              <b>incongruencias en los instrumentos de planeación de territorio</b>
              (Planes de Desarrollo Urbano y Programas de Ordenamiento Ecológico).
            </p>
            <h4>Estatus de las minas en la RNOCM</h4>
            <img
              src="@/assets/fichas-diagnostico/minas/Estatus-MInas-Dona.png"
              class="vis m-b-1"
              alt="Legales 22.42%, Ilegales 18.18%, Sin datos 59.34%"
            />
          </div>
        </div>
      </div>

      <div class="ficha-separador"></div>

      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img src="@/assets/fichas-diagnostico/minas/Mina-La-Puerta.png" class="foto" alt="" />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Mina La Puerta, Nopaltepec en 2001 y 2020</p>
          </div>
          <div class="ficha-titulo">
            <h4>Impacto de la explotación mineral en la RNOCM</h4>
          </div>
          <div class="ficha-cuerpo">
            <p class="m-t-0-md">
              Entre las consecuencias de mayor impacto en la región por las
              actividades extractivas se encuentran el
              <b>cambio de uso de suelo</b> en terrenos forestales; los
              <b>daños a cuerpos de agua</b> y zonas de importancia para la
              recarga de los acuíferos; la
              <b>perturbación de hábitats de fauna</b> silvestre (como el
              ajolote); la <b>afectación en viviendas</b>, principalmente,
              <b>por el uso de explosivos C4</b> y su proximidad a los bancos de
              materiales, y el <b>daño a los sitios arqueológicos</b> en el
              Techachalen Tepetlaoxtoc, Tetzcutzingo en Texcoco.
            </p>
            <h4>Operación en las minas de la RNOCM</h4>
            <img
              src="@/assets/fichas-diagnostico/minas/Operacion-Minas-Barras.png"
              alt=""
              class="vis m-b-1"
            />
          </div>
        </div>
      </div>

      <div class="ficha-separador"></div>

      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img src="@/assets/fichas-diagnostico/minas/4-Uso de suelo.png" class="foto" alt="" />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Banco de materiales en Tezoyuca de Texcoco</p>
          </div>
          <div class="ficha-titulo">
            <h4>Banco de materiales pétreos</h4>
          </div>
          <div class="ficha-cuerpo">
            <ul class="margin-fix-mina">
              <li>
                El proyecto del exNAICM requirió de la explotación de aprox. 233
                bancos de materiales. Los principales materiales de explotación
                mineral fueron arena, grava y tezontle.
              </li>
              <li>
                199 de los 233 bancos de materiales se encuentran en operación y
                el restante 14.6% está inactivo.
              </li>
              <li>Se estima que 179 bancos (75%) operan ilegalmente.</li>
            </ul>
          </div>
        </div>
        <p class="ficha-texto-adicional">
          *UGA = Unidad de Gestión Ambiental, como se establece en la Ley
          General del Equilibrio Ecológico y la Protección al Ambiente (LEGEPA)
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Minas",
};
</script>

<style lang="scss" scoped>
.margin-fix-mina {
  margin-top: 1em;
}
</style>